import {
	getLeCoffreAccessTokenCookieForContext,
	type LeCoffreAuthContext,
} from "@Front/Utils/lecoffreSessionCookieHelpers";
import { getActiveSessionFamily } from "@Front/Utils/lecoffreActiveSessionFamily";
import {
	getTokenFromConnectedStoreByContext,
	resolveActiveAuthContextFromCookies,
	resolveActiveAuthContextFromStores,
} from "@Front/Api/helpers/authTokenResolutionHelpers";

function familyHasLiveToken(family: LeCoffreAuthContext): boolean {
	return Boolean(getTokenFromConnectedStoreByContext(family) || getLeCoffreAccessTokenCookieForContext(family));
}

/**
 * Live auth family regardless of the current URL.
 * Route-scoped resolution returns null for a customer on `/folders/...`.
 */
export function resolveLiveAuthContextIgnoringRoute(): LeCoffreAuthContext | null {
	const family = getActiveSessionFamily();
	if (family && familyHasLiveToken(family)) {
		return family;
	}
	return resolveActiveAuthContextFromStores() ?? resolveActiveAuthContextFromCookies();
}
